// Shim for Node.js url module's parse function
// Uses the browser's native URL API

export function parse(urlString, parseQueryString = false, slashesDenoteHost = false) {
    try {
        // Check if it's an absolute URL (has protocol)
        const isAbsolute = /^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(urlString);

        if (isAbsolute) {
            // Parse absolute URLs directly
            const url = new URL(urlString);
            return {
                protocol: url.protocol,
                slashes: url.protocol.endsWith(':'),
                auth: url.username ? (url.password ? `${url.username}:${url.password}` : url.username) : null,
                host: url.host,
                port: url.port || null,
                hostname: url.hostname,
                hash: url.hash || null,
                search: url.search || null,
                query: parseQueryString ? Object.fromEntries(url.searchParams) : url.search?.slice(1) || null,
                pathname: url.pathname,
                path: url.pathname + (url.search || ''),
                href: url.href
            };
        } else {
            // For relative URLs, don't resolve against window.location
            // Just parse the path components
            const hashIndex = urlString.indexOf('#');
            const searchIndex = urlString.indexOf('?');

            let pathname = urlString;
            let search = null;
            let hash = null;

            if (hashIndex !== -1) {
                hash = urlString.slice(hashIndex);
                pathname = urlString.slice(0, hashIndex);
            }

            if (searchIndex !== -1 && (hashIndex === -1 || searchIndex < hashIndex)) {
                search = pathname.slice(searchIndex, hashIndex !== -1 ? hashIndex - searchIndex : undefined);
                pathname = pathname.slice(0, searchIndex);
            }

            return {
                protocol: null,
                slashes: null,
                auth: null,
                host: null,
                port: null,
                hostname: null,
                hash: hash,
                search: search,
                query: parseQueryString && search ? Object.fromEntries(new URLSearchParams(search)) : search?.slice(1) || null,
                pathname: pathname,
                path: pathname + (search || ''),
                href: urlString
            };
        }
    } catch (e) {
        // Return a minimal object for invalid URLs
        return {
            protocol: null,
            slashes: null,
            auth: null,
            host: null,
            port: null,
            hostname: null,
            hash: null,
            search: null,
            query: null,
            pathname: urlString,
            path: urlString,
            href: urlString
        };
    }
}

export function format(urlObject) {
    if (typeof urlObject === 'string') return urlObject;

    let result = '';
    if (urlObject.protocol) result += urlObject.protocol;
    if (urlObject.slashes) result += '//';
    if (urlObject.auth) result += urlObject.auth + '@';
    if (urlObject.host) result += urlObject.host;
    else if (urlObject.hostname) {
        result += urlObject.hostname;
        if (urlObject.port) result += ':' + urlObject.port;
    }
    if (urlObject.pathname) result += urlObject.pathname;
    if (urlObject.search) result += urlObject.search;
    if (urlObject.hash) result += urlObject.hash;
    return result;
}

export function resolve(from, to) {
    return new URL(to, from).href;
}

export default { parse, format, resolve };
